import { render } from "./ArgonRadio.vue?vue&type=template&id=1b994818"
import script from "./ArgonRadio.vue?vue&type=script&lang=js"
export * from "./ArgonRadio.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__